import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
  selector: 'app-simple-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div class="simple-layout">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [
    `
      .simple-layout {
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
})
export class SimpleLayoutComponent {}
